import React from 'react';
import './Style.css';
const Index = () => {
    return (
        <div
            style={{
                overflowY: 'hidden',
                overflowX: 'auto',

                boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
                marginTop: '1.5rem',
                borderRadius: '10px',
            }}
        >
            <table className="wallet-transaction_table">
                <thead className="wallet-transaction_table_head">
                    <tr className="wallet-transaction_table_head_row">
                        <td className="wallet-transaction_table_head_data">Date</td>
                        <td className="wallet-transaction_table_head_data">TXN Type</td>
                        <td className="wallet-transaction_table_head_data">Ref No.</td>
                        <td className="wallet-transaction_table_head_data">Transaction ID</td>

                        <td className="wallet-transaction_table_head_data">Credit (Rs.)</td>

                        <td className="wallet-transaction_table_head_data">Debit (Rs.)</td>

                        <td className="wallet-transaction_table_head_data">Closing Balance (Rs.)</td>

                        <td className="wallet-transaction_table_head_data">Description</td>
                    </tr>
                </thead>
                <tbody className="wallet-transaction_table_body">
                    <Component
                        date="May 18, 2021 13:56"
                        txn="Shipping"
                        reference="14189919254981"
                        id="#9385965"
                        credit="103"
                        balance="9279"
                        description="RTO Extra Weight Charges Refunded"
                    />
                    <Component
                        date="May 18, 2021 13:56"
                        txn="Shipping"
                        reference="14189919254981"
                        id="#9385965"
                        credit="103"
                        balance="9279"
                        description="RTO Extra Weight Charges Refunded"
                    />
                    <Component
                        date="May 18, 2021 13:56"
                        txn="Shipping"
                        reference="14189919254981"
                        id="#9385965"
                        credit="103"
                        balance="9279"
                        description="RTO Extra Weight Charges Refunded"
                    />
                    <Component
                        date="May 18, 2021 13:56"
                        txn="Shipping"
                        reference="14189919254981"
                        id="#9385965"
                        credit="103"
                        balance="9279"
                        description="RTO Extra Weight Charges Refunded"
                    />
                    <Component
                        date="May 18, 2021 13:56"
                        txn="Shipping"
                        reference="14189919254981"
                        id="#9385965"
                        credit="103"
                        balance="9279"
                        description="RTO Extra Weight Charges Refunded"
                    />
                    <Component
                        date="May 18, 2021 13:56"
                        txn="Shipping"
                        reference="14189919254981"
                        id="#9385965"
                        credit="103"
                        balance="9279"
                        description="RTO Extra Weight Charges Refunded"
                    />
                    <Component
                        date="May 18, 2021 13:56"
                        txn="Shipping"
                        reference="14189919254981"
                        id="#9385965"
                        credit="103"
                        balance="9279"
                        description="RTO Extra Weight Charges Refunded"
                    />
                    <Component
                        date="May 18, 2021 13:56"
                        txn="Shipping"
                        reference="14189919254981"
                        id="#9385965"
                        credit="103"
                        balance="9279"
                        description="RTO Extra Weight Charges Refunded"
                    />
                    <Component
                        date="May 18, 2021 13:56"
                        txn="Shipping"
                        reference="14189919254981"
                        id="#9385965"
                        credit="103"
                        balance="9279"
                        description="RTO Extra Weight Charges Refunded"
                    />
                    <Component
                        date="May 18, 2021 13:56"
                        txn="Shipping"
                        reference="14189919254981"
                        id="#9385965"
                        credit="103"
                        balance="9279"
                        description="RTO Extra Weight Charges Refunded"
                    />
                </tbody>
            </table>
        </div>
    );
};

const Component = ({ date, txn, reference, id, credit, debit, balance, description }) => {
    return (
        <tr className="wallet-transaction_table_body_row">
            <td className="wallet-transaction_table_body_data">{date}</td>
            <td className="wallet-transaction_table_body_data">{txn}</td>
            <td className="wallet-transaction_table_body_data">
                <p style={{ color: 'rgba(252, 97, 1, 1)' }}>{reference}</p>
            </td>
            <td className="wallet-transaction_table_body_data">{id}</td>
            <td className="wallet-transaction_table_body_data">{credit ? credit : '-'}</td>
            <td className="wallet-transaction_table_body_data">{debit ? debit : '-'}</td>

            <td className="wallet-transaction_table_body_data">{balance}</td>
            <td className="wallet-transaction_table_body_data">{description}</td>
        </tr>
    );
};
export default Index;
